import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div
          role="alert"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "40vh",
            padding: "var(--space-4)",
            textAlign: "center",
            gap: "var(--space-2)",
          }}
        >
          <div style={{ fontSize: "var(--type-h1)" }}>{"\uD83C\uDF3E"}</div>
          <h2 style={{ margin: 0, fontSize: "var(--type-h2)" }}>{this.props.t("common.error_title", { defaultValue: "Something went wrong" })}</h2>
          <p style={{ margin: 0, opacity: 0.7, maxWidth: "400px" }}>
            {this.props.t("common.error_description", { defaultValue: "We hit an unexpected issue. Please try again or refresh the page." })}
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: "var(--space-1) var(--space-3)",
              borderRadius: "999px",
              border: "none",
              background: "var(--color-accent-primary)",
              color: "var(--color-text-inverse)",
              fontWeight: 600,
              fontSize: "var(--type-sm)",
              cursor: "pointer",
            }}
          >
            {this.props.t("common.try_again", { defaultValue: "Try Again" })}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
